import React from 'react';

import {
  POISearcher,
  POIMap,
  POISearcherContextProvider,
  POIMapContextProvider,
  POIVenuesContextProvider,
  POIVenuesList,
} from 'modules/point-of-interest';

const POISection = ({ className }) => {
  return (
    <POIMapContextProvider>
      <POIVenuesContextProvider>
        <POISearcherContextProvider>
          <div className={className} data-testid="POISection">
            <div className="sidebar">
              <POISearcher />
              <POIVenuesList />
            </div>
            <POIMap className="map-container" />
          </div>
        </POISearcherContextProvider>
      </POIVenuesContextProvider>
    </POIMapContextProvider>
  );
};

export default POISection;
